class AnchorButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.href = this.getAttribute("href");
    this.href = this.href.replace("#", "");
    this.target = document.getElementById(this.href);
    this.addEventListener("click", () => this.handleClick(this.target));
  }

  handleClick(elem) {
    console.log(elem);
    if (elem) {
      elem.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }
}

customElements.define("anchor-button", AnchorButton);
